import React, { PureComponent } from "react";
import styled from "styled-components";

const BurgerStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 26px;
  height: 18px;
  cursor: pointer;
  .bar {
    height: 2px;
    background-color: #ffffff;
    transition: all 0.6s;
  }
  &:hover {
    .bar {
      background-color: #8a774a;
    }
  }
`;

export default class Burger extends PureComponent {
  render() {
    return (
      <BurgerStyled {...this.props} className="burger-component">
        <div className="bar" />
        <div className="bar" />
        <div className="bar" />
      </BurgerStyled>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Burger.js